import {
  Component,
  ElementRef,
  HostListener,
  OnInit,
  ViewChild,
} from '@angular/core';
import {
  FormArray,
  FormBuilder,
  FormControl,
  FormGroup,
  Validators,
} from '@angular/forms';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { ResponseBase, ScreenModel,RequestData } from '../../../../core/models/common';
import {
  FileUpload,
  FileUploadServerData,
  Workflow,
} from '../../../../core/models/fna';
import { ApiService } from '../../../../core/services/api-mock.service';
import { GlobalsService } from '../../../../core/services/globals.service';
import { BasicModalComponent } from '../../components/basic-modal/basic-modal.component';
import { UploadedFile } from '../../../../core/components/file-upload/file-upload.component';
// @TODO: Clean up unused variables i.e. IsReadDocumentsChecked
// What we receive from the API, and will send to the API.
export interface AccreditedInvestorOptInData extends ResponseBase {
  IsOptInAccreditedInvestor?: boolean;
  IsReadAccreditedInvestorDescription?: boolean;
  IsReadAccreditedInvestorExplanation?: boolean;
  AuditedBalanceSheet?: FileUploadServerData | null;
  OtherDocuments?: FileUploadServerData[] | null;
}

// What we work with in this screen.
export class AccreditedInvestorOptInModel extends ScreenModel {
  screenName = 'AccreditedInvestorOptIn';
  pageID_read = 'R0031';
  pageID_write = 'S0031';
  data: AccreditedInvestorOptInData | undefined;
  isOptInAccreditedInvestor?: boolean;
  isReadAccreditedInvestorDescription: boolean = false;
  isReadAccreditedInvestorExplanation: boolean = false;
  auditedBalanceSheet?: FileUpload | undefined;
  otherDocuments?: FileUpload[] | undefined;

  // Data lifecycle start.
  mapPegaObjToUI(data : any){
    console.log("FIRSTEVER MAPPING TEST +++++++")
    console.log(data)
    //let riskQuestionList = data['RiskandObjectiveDetails']['RiskandObjectives']
    
    let accreditedInvestorOptInData :AccreditedInvestorOptInData = {
      IsOptInAccreditedInvestor: data['AccreditedInvestor']=='Yes'?true:data['AccreditedInvestor']=='No'?false:undefined,
      //IsReadDocumentsChecked: true,
      AuditedBalanceSheet:data['CapturedDocuments']?{
        FileId: '1',
        Name: data['CapturedDocuments']['DocName'],
        Data:data['CapturedDocuments']['Value'],
        Size: 7,
        Type: data['CapturedDocuments']['ExtensionType'],
        DocumentType: data['CapturedDocuments']['DocumentType']
      }:null

    }
     
     return accreditedInvestorOptInData;
   }
  deriveFromData(data: AccreditedInvestorOptInData) {
    
    this.isOptInAccreditedInvestor = data.IsOptInAccreditedInvestor;
    this.isReadAccreditedInvestorDescription = data.IsOptInAccreditedInvestor==undefined?false:true;
    this.isReadAccreditedInvestorExplanation = data.IsOptInAccreditedInvestor==undefined?false:true;
      data.IsReadAccreditedInvestorExplanation || false;
    
    
      if (data.AuditedBalanceSheet) {
      this.auditedBalanceSheet = {
        fileId: data.AuditedBalanceSheet.FileId,
        name: data.AuditedBalanceSheet.Name,
        data: data.AuditedBalanceSheet.Data,
        size: data.AuditedBalanceSheet.Size,
        type: data.AuditedBalanceSheet.Type,
      };
    }
    if (data.OtherDocuments?.length) {
      this.otherDocuments = data.OtherDocuments.map((document) => {
        return {
          fileId: document.FileId,
          name: document.Name,
          data: document.Data,
          size: document.Size,
          type: document.Type,
        };
      });
    }
    console.log('deriveFromData, model:', this);
  }

  // Constructs a JSON object to be sent to server.
  deriveDataFromModel(): RequestData {
    // @For integration.
    
    console.log(this.otherDocuments)
    let docList:any[] = [];
    if(this.otherDocuments){
     docList = this.otherDocuments.map((document:any)=>{
        return document?{
          DocName:document.name,
          Value:document.data,
          ExtensionType:document.type,
          DocumentType:'Supporting Docs'
        }:null
      })
    }
    if(this.auditedBalanceSheet){
      docList.push({
        DocName:this.auditedBalanceSheet.name,
        Value:this.auditedBalanceSheet.data,
        ExtensionType:this.auditedBalanceSheet.type,
        DocumentType:'Audited Balance Sheet'
      })
    }
   
    
    return {
      ServiceBody :{AccreditedInvestor :this.isOptInAccreditedInvestor?'Yes':'No',
                    CapturedDocuments : docList?docList:null

                    
      }// this.isQualifiedAccreditedInvestor}
    };


    // return {
    //   IsOptInAccreditedInvestor: this.isOptInAccreditedInvestor,
    //   IsReadDocumentsChecked: this.isReadDocumentsChecked,
    //   AuditedBalanceSheet: this.auditedBalanceSheet
    //     ? {
    //         FileId: this.auditedBalanceSheet.fileId,
    //         Name: this.auditedBalanceSheet.name,
    //         Data: this.auditedBalanceSheet.data,
    //         Size: this.auditedBalanceSheet.size,
    //         Type: this.auditedBalanceSheet.type,
    //       }
    //     : null,
    // };
  }

  // Data lifecycle end.

  syncModelWithForm() {
    console.log('[AccreditedInvestorModel] syncModelWithForm');
    const formValues = this.form?.value;
    this.isOptInAccreditedInvestor = formValues.isOptInAccreditedInvestor;
    this.isReadAccreditedInvestorDescription =
      formValues.isReadAccreditedInvestorDescription;
    this.isReadAccreditedInvestorExplanation =
      formValues.isReadAccreditedInvestorExplanation;
    this.auditedBalanceSheet = {
      ...formValues.auditedBalanceSheetFile?.uploadedFiles[0]?.file,
    };

    this.otherDocuments = formValues.otherDocument?.uploadedFiles.map(
      (file: UploadedFile) => {
        return {
          fileId: file.file.id,
          name: file.file.name,
          size: file.file.size,
          type: file.file.type,
          data: file.file.data,
        };
      },
    );
  }

  validate() {
    if (!this.isSubmitted) {
      return;
    }

    if (!this.form) {
      return;
    }

    this.isValid = this.form.valid;
  }
}

@Component({
  selector: 'app-accredited-investor-opt-in',
  templateUrl: './accredited-investor-opt-in.component.html',
  styleUrls: ['./accredited-investor-opt-in.component.scss'],
})
export class AccreditedInvestorOptInComponent implements OnInit {
  model = new AccreditedInvestorOptInModel(
    this.globals,
    this.apiService,
    this.el,
  );
  form: FormGroup = this.formBuilder.group({
    isOptInAccreditedInvestor: [undefined, [Validators.required]],
    isReadAccreditedInvestorDescription: [false],
    isReadAccreditedInvestorExplanation: [false],
    auditedBalanceSheetFile: this.formBuilder.group({
      uploadedFiles: this.formBuilder.array([]),
    }),
    otherDocument: this.formBuilder.group({
      uploadedFiles: this.formBuilder.array([]),
    }),
  });

  @ViewChild('confirmationModal')
  confirmationModal: ElementRef | undefined;

  constructor(
    private router: Router,
    public globals: GlobalsService,
    protected apiService: ApiService,
    private formBuilder: FormBuilder,
    private modalService: NgbModal,
    private el: ElementRef,
  ) {
    this.model.form = this.form;
    this.model.initializeForm = this.initializeForm;
    this.model.goToNextScreen = this.goToNextScreen;
    this.model.goToPreviousScreen = this.goToPreviousScreen;
  }

  async ngOnInit() {
    await this.model.loadData();
  }

  @HostListener('window:beforeunload', ['$event'])
  onBeforeUnload($event: any) {
    $event.returnValue =
      'Changes to your data will be lost! Are you sure you want to exit?';
  }

  initializeForm = () => {
    this.formControlValueChanged();



    this.isReadAccreditedInvestorDescriptionControl.setValue(
      this.model.isReadAccreditedInvestorDescription,
    );

    this.isReadAccreditedInvestorExplanationControl.setValue(
      this.model.isReadAccreditedInvestorExplanation,
    );

    this.isOptInAccreditedInvestorControl.setValue(this.model.isOptInAccreditedInvestor);

    

    if (this.model.auditedBalanceSheet) {
      this.auditedBalanceSheetFileFormArray.push(
        new FormControl({
          file: this.model.auditedBalanceSheet,
        }),
      );
    }

    if (this.model.otherDocuments?.length) {
      this.model.otherDocuments.forEach((document) => {
        this.otherDocumentFormArray.push(
          new FormControl({
            file: document,
          }),
        );
      });
    }
  };

  goToPreviousScreen = async () => {
    console.log('[AccreditedInvestorOptInComponent] goToPreviousScreen');
    await this.router.navigateByUrl('/fna/accredited-investor');
  };

  goToNextScreen = async () => {
    console.log('[AccreditedInvestorOptInComponent] goToNextScreen');
    console.log(
      '[isOptInAccreditedInvestor]',
      this.model.isOptInAccreditedInvestor,
    );
    if (this.model.isOptInAccreditedInvestor) {
      // VALIDATE FORM
      await this.router.navigate(['/fna/accredited-investor-confirmation'], {
        queryParams: { workflow: Workflow.AI },
      });
    } else {
      await this.router.navigateByUrl('/fna/organisation-information');
    }
  };

  showAccreditedInvestorDescriptionModal() {
    this.isReadAccreditedInvestorDescriptionControl.setValue(true);

    const modalRef = this.modalService.open(BasicModalComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.componentInstance.title = 'Accredited Investors';
    modalRef.componentInstance.content =
      'Accredited Investors (AIs) are asummed to be better informed, and better able to access resources to protect their own interests, and therefore require regulatory protection. Investors who agree to be treated as AIs therefore forgo the benefit of certain regulatory safeguards. For example, issuers of securities are exempted from issuing a full prospectus registered with Monetary Authority of Singapore in respect of offers that are made only to AIs, and the intermediaries are exempted from a number of business conduct requirements when dealing with AIs. You should consult a professional adviser if you do not understand any consequences of being treated as an AI.';
  }

  handleOnClickAccreditedInvestorExplanation() {
    this.isReadAccreditedInvestorExplanationControl.setValue(true);
  }

  handleOnSelectAccreditedInvestorOptIn(event: any, radioValue: boolean) {
    if (this.isOptInAccreditedInvestorControl.disabled) {
      return;
    }

    let shouldPromptUser = false;

    if (
      this.isOptInAccreditedInvestorControl.value &&
      (this.auditedBalanceSheetFileFormArray.length ||
        this.otherDocumentFormArray.length)
    ) {
      shouldPromptUser = true;
    }

    if (shouldPromptUser) {
      event.preventDefault();
      event.stopPropagation();
      this.modalService
        .open(this.confirmationModal, { ariaLabelledBy: 'modal-basic-title' })
        .result.then(
          (result) => {
            console.log('Confirmation modal result: ', result);
            if (result == 'save') {
              console.log('event.target.value: ', event);
              this.isOptInAccreditedInvestorControl.setValue(radioValue);
              this.auditedBalanceSheetFileFormArray.clear();
              this.otherDocumentFormArray.clear();
            }
          },
          (reason) => {},
        );
      return;
    }

    this.isOptInAccreditedInvestorControl.setValue(radioValue);
  }

  showAuditedBalanceSheetErrorModal(message: string) {
    const modalRef = this.modalService.open(BasicModalComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.componentInstance.title = 'Unable to upload file';
    modalRef.componentInstance.content = message;
    modalRef.componentInstance.buttonText = 'Okay';
  }

  showOtherDocumentErrorModal(message: string) {
    const modalRef = this.modalService.open(BasicModalComponent, {
      size: 'lg',
      centered: true,
    });
    modalRef.componentInstance.title = 'Unable to upload file';
    modalRef.componentInstance.content = message;
    modalRef.componentInstance.buttonText = 'Okay';
  }

  // region Form controls validation
  formControlValueChanged() {
    this.isReadAccreditedInvestorDescriptionControl.valueChanges.subscribe(
      (isChecked) => {
        if (
          isChecked &&
          this.isReadAccreditedInvestorExplanationControl.value
        ) {
          this.isOptInAccreditedInvestorControl.enable();
        } else {
          this.isOptInAccreditedInvestorControl.disable();
        }
      },
    );

    this.isReadAccreditedInvestorExplanationControl.valueChanges.subscribe(
      (isChecked) => {
        if (
          isChecked &&
          this.isReadAccreditedInvestorDescriptionControl.value
        ) {
          this.isOptInAccreditedInvestorControl.enable();
        } else {
          this.isOptInAccreditedInvestorControl.disable();
        }
      },
    );
  }
  // endregion

  // Form controls

  get isOptInAccreditedInvestorControl() {
    return this.form.get('isOptInAccreditedInvestor') as FormControl;
  }

  get isReadAccreditedInvestorDescriptionControl() {
    return this.form.get('isReadAccreditedInvestorDescription') as FormControl;
  }

  get isReadAccreditedInvestorExplanationControl() {
    return this.form.get('isReadAccreditedInvestorExplanation') as FormControl;
  }

  get auditedBalanceSheetFileFormGroup() {
    return this.form.get('auditedBalanceSheetFile') as FormGroup;
  }

  get auditedBalanceSheetFileFormArray() {
    return this.auditedBalanceSheetFileFormGroup.get(
      'uploadedFiles',
    ) as FormArray;
  }

  get otherDocumentFormGroup() {
    return this.form.get('otherDocument') as FormGroup;
  }

  get otherDocumentFormArray() {
    return this.otherDocumentFormGroup.get('uploadedFiles') as FormArray;
  }

  // Form controls end
}
